<script lang="ts" setup>
  import type { CheckboxCustomEvent } from '@ionic/core/dist/types/components/checkbox/checkbox-interface'

  const props = withDefaults(
    defineProps<{
      modelValue: boolean
      disabled?: boolean
      indeterminate?: boolean
      justify?: 'end' | 'space-between' | 'start'
      labelPlacement?: 'start' | 'end' | 'fixed' | 'stacked'
      name: string
    }>(),
    {
      disabled: false,
      indeterminate: false,
      justify: 'space-between',
      labelPlacement: 'end'
    }
  )

  const emit = defineEmits<{
    (event: 'update:modelValue', value: boolean): void
    (event: 'change', payload: CheckboxCustomEvent): void
    (event: 'focus'): void
    (event: 'blur'): void
  }>()

  const value = computed<boolean>({
    get: () => props.modelValue,
    set: (newValue) => {
      emit('update:modelValue', newValue)
    }
  })
</script>

<template>
  <ion-checkbox
    :checked="value"
    :disabled="disabled"
    :indeterminate="indeterminate"
    :justify="justify"
    :label-placement="labelPlacement"
    :name="name"
    @ion-change="value = $event.detail.checked"
    @ion-focus="$emit('focus')"
    @ion-blur="$emit('blur')"
  >
    <slot />
  </ion-checkbox>
</template>

<style lang="scss" scoped>
  ion-checkbox {
    --border-radius: 0px;
  }

  ion-checkbox::part(label) {
    white-space: normal;
  }
</style>
